import axios from "axios";
//import * as auth from "src/services/authService";
// import { toast } from "react-toastify";
import { toast } from "react-toastify";
import logger from "./logService";
import { getCaption } from "src/utils/dictionary";

const tokenKey = "accessToken";
const axiosInstance = axios.create();

const getToken = () => {
  return localStorage.getItem(tokenKey);
};

function setAccessToken() {
  axiosInstance.defaults.headers.common.Authorization = `bearer ${getToken()}`;
}
setAccessToken();

function getApiURL() {
  //return "http://localhost:61682//api";
  return window.REACT_APP_API_URL;
  //TODO : >> GET FROM CONFIG FILE
}

function getLang() {
  try {
    const APP_LANG = localStorage.getItem("APP_LANG");
    return APP_LANG || "en";
  } catch {}
  return "en";
}

export function getSelectedCompany() {
  try {
    return JSON.parse(localStorage.getItem("selectedCompany"));
  } catch {}

  return null;
}

export function getSelectedBranch() {
  try {
    return JSON.parse(localStorage.getItem("selectedBranch"));
  } catch {}

  return null;
}

// axios.defaults.headers.common.Authorization = `bearer ${token}`; // for all requests
axiosInstance.defaults.headers.common.Lang = getLang(); // for all requests
axiosInstance.defaults.headers.common.companyId = getSelectedCompany()?.id; // for all requests
axiosInstance.defaults.headers.common.branchId = getSelectedBranch()?.id; // for all requests
// axios.defaults.headers.post['header1'] = 'value' // for POST requests
// axios.defaults.headers.get['header1'] = 'value' // for GET requests

axiosInstance.interceptors.response.use(null, (error) => {
  // if (error.response && error.response.status) {
  console.log(error);
  // }
  if (error.response && error.response.status === 401) {
    toast.error(getCaption("authorization_error"));
    if (window.location.pathname !== "/auth/sign-in") {
      window.location.href = "/auth/sign-in";
      //auth.logout();
    }
  }
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    logger.log(getCaption("unexpected_error_occurred"));
    toast.error(
      error?.response?.data || getCaption("unexpected_error_occurred")
    );
  }

  return Promise.reject(error);
});

function deleteAccessToken() {
  delete axiosInstance.defaults.headers.common.Authorization;
}
export default {
  axiosInstance,
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
  setAccessToken,
  deleteAccessToken,
  getApiURL,
  tokenKey,
};
